/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of IBM                              */
/*                                                                   */
/* (C) Copyright IBM Corp. 2022                                      */
/*                                                                   */
/* ***************************************************************** */
import queryString from 'query-string';
import {contentSetMap} from './content-set-map'

import { get, isEmptyObject } from "./";
import {
    TITLE_DRUG_CONSULT_PAGE,
    TITLE_DRUG_INTERACTION_DETAIL_PAGE,
    TITLE_DRUG_INTERACTION_RESULT_SUMMARY_PAGE,
    TITLE_DRUG_INTERACTION_SEARCH_PAGE,
    TITLE_DRUG_MONOGRAPHS_RESULTS,
    TITLE_DRUG_MONOGRAPHS_SEARCH,
    TITLE_ENTERAL_FORMULAS,
    TITLE_ENTERAL_FORMULAS_NUTRIENT_DETAILS,
    TITLE_ENTERAL_FORMULAS_PRODUCT_NOTES,
    TITLE_HOME_PAGE,
    TITLE_IV_COMPATIBILITY_PRODUCT_DOCUMENT_PAGE,
    TITLE_IV_COMPATIBILITY_RESULT_DETAILS_PAGE,
    TITLE_IV_COMPATIBILITY_RESULT_SUMMARY_PAGE,
    TITLE_IV_COMPATIBILITY_SEARCH_PAGE,
    TITLE_LOGIN_PAGE,
    TITLE_MICROMEDEX_ASSISTANT,
    TITLE_MONOGRAPH_IN_DEPTH_ANSWERS,
    TITLE_MONOGRAPH_QUICK_ANSWERS
} from "../components/common/constants";
import {
    NEO_PED_DRUG_ID_KEY,
    NO_PAGE_VIEW_TRACKING,
    SECTION_TYPE_DRUGS
} from "../pages/NeoFaxPediatricsPage/common/constants";

// Amplitude authentication lifecycle event names. Must match the Micromedex3 Amplitude project.
export const AUTH_EVENTS = {
    AUTH_SCREEN_SUBMIT: 'Auth Screen Submit',
    AUTH_SUCCESS: 'Auth Success',
    LOGOUT: 'Logout'
};

// Values for the "Action" property on the Auth Success event.
export const AUTH_ACTION = {
    LOGIN: 'Login'
};

// Maps backend identityProvider values to the canonical Amplitude Auth Type codes. Values already
// in canonical form pass through unchanged.
export const AUTH_TYPE_MAP = {
    ENTRA_ID: 'ENTRA'
};

// Normalizes a backend auth type / identityProvider value to its canonical Amplitude code.
export function normalizeAuthType(authType) {
    if (!authType) {
        return authType;
    }
    return AUTH_TYPE_MAP[authType] || authType;
}

export function trackMessageEvents(message)
{
    console.debug('inside trackMessageEvents -------------->', message);
    try {
    if (window.amplitude) {
        console.log("Message tracking....", message)
             window.amplitude.track('Message Events', message);
       }
    } catch(e) {
      console.error("Error while sending data to Adobe ", e);
    }
}

export function addUserId(authenticationJson={})
{
    var metaTagUserName = document.createElement('meta');
    metaTagUserName.name = 'userid';
    metaTagUserName.content = authenticationJson.userId ;
    metaTagUserName.id = 'userid';
    document.getElementsByTagName('head')[0].appendChild(metaTagUserName);
}

export function addParentSiteMetatag(authenticationJson={})
{
    if (get(authenticationJson, 'Client_Config.secured_origins', '')) {
        var metaTagParentSite = document.createElement('meta');
        metaTagParentSite.name = 'parentSite';
        metaTagParentSite.content = get(authenticationJson, 'Client_Config.secured_origins', '');
        metaTagParentSite.id = 'parentSite';
        document.getElementsByTagName('head')[0].appendChild(metaTagParentSite);
    }
}

export function checkForIframe()
{
    var metaTagiFrameIndicator = document.createElement('meta');
    metaTagiFrameIndicator.name = 'isInIframeFlag';
    metaTagiFrameIndicator.id = 'isInIframeFlag';
    metaTagiFrameIndicator.content = 'TRUE';
    document.getElementsByTagName('head')[0].appendChild(metaTagiFrameIndicator);   
}

export function trackPageNavigation(location,pageName)
{
    console.debug('Inside trackPageNavigation ', location);
    if (location) {
        let queryParams = {};
        if (location.search) {
            queryParams = queryString.parse(location.search);
        }
        if (pageName) {
            if (pageName.charAt(0) === '/') {
                pageName = pageName.substring(1);
            }
            console.log("Page Name",pageName)
            if (pageName) {
                queryParams['pageName'] = pageName;
            }
        }
        let keywordValue;
        if(window.accountInfo){
            for (var key in window.accountInfo) {
                if (window.accountInfo[key] && window.accountInfo[key].toString().indexOf("$", 0) !== "0") {
                    keywordValue = window.accountInfo[key] !== 'NA' ? window.accountInfo[key]: "null";
                    queryParams[key] = keywordValue.toString().trim();
                }
            }
        }
        trackAmplitude(queryParams);
    }
}

/**
 * Generic method to send data to Amplitude
 * @param keyValueMap a Javascript object that is treated as a key/value pair map of
 * items to send to Adobe Analytics
 * @param contentSetId (optional) a contentSetId that is needed when retrieving the document
 */
export function trackAmplitude(keyValueMap, contentSetId)
{
    console.debug('ENTER trackAmplitude: keyValueMap=', keyValueMap, ' contentSetId=', contentSetId);
    if (isEmptyObject(keyValueMap)) {
        console.debug("ERROR trackAmplitude: EMPTY keyValueMap!");
        return;
    }
    try {
        if (window.amplitude) {
            console.log("Key value track",keyValueMap)
            let docRetrievalDetails;
            if (contentSetId) {
                docRetrievalDetails = { ContentSetId: contentSetId }
            }
            window.exPageTrack(keyValueMap, "", "false", "", docRetrievalDetails);
        } else {
            console.debug('ERROR trackAmplitude: window.amplitude not available');
        }
    } catch(e) {
        console.error("ERROR trackAmplitude caught Exception:", e);
    }
}

export function trackAccountEvents(accountInfo) 
{
    console.log('inside trackMessageEvents -------------->'+ accountInfo);
    let dimentionMap={}
    if(get(accountInfo, 'customerId')){dimentionMap["OrgID"]= get(accountInfo, 'customerId')}
    if(get(accountInfo, 'issuerUrl')){dimentionMap["IssuerURL"]= get(accountInfo, 'issuerUrl')}
    if(get(accountInfo, 'accountName')){dimentionMap["AccountName"]= get(accountInfo, 'accountName')}
    if(get(accountInfo, 'AuthenticationType'))dimentionMap["AuthenticationType"]= get(accountInfo, 'AuthenticationType')
    // trackAdobeAnalytics(DCR_PAGE_NAVIGATION, dimentionMap);
}

/**
 * Similar to online implementation
 */

window._ivcomp_helpers = {
    trackTabClick(tabName = '') {
        console.log(tabName);
        window.exPageTrack("", tabName, "true", "", ""); // TBD: Not sure if we need call Adobe Analytics
    },
    trackDocumentRetrieval(contentSetId = '', documentIds = [], documentName) {
        console.log(contentSetId, documentIds, documentName);
        window.exPageTrack("","","false","",
            // docRetrievalDetails parameter
            {
                ContentSetId: contentSetId,
                DocumentId: documentIds.join('|'),
                DocumentName: documentName,
                actionType: 'DocRetrieval'
            })
        // TODO: not sure how to track documentName
    },
    trackDocumentSearch(drugs = [], solutions = [], contentSetId = '', popularIVDrugPairs = false) {
        console.log("search call is coming in for adobe tracking")
        window.exPageTrack(
            // userInputString parameter
            {
                actionType: 'SearchAndDocRetrieval',
                searchType: 'IV Search',
                countOfIVDrugsSelected: drugs.length,
                ivDrugNames: drugs.join('|'),
                countOfIVSolutionsSelected: solutions.length,
                ivSolutionNames: solutions.join('|'),
                popularIVDrugPairs: popularIVDrugPairs
            },
            "", "false", "",
            { ContentSetId: contentSetId })
    },
    trackDocumentRetrievalDetails(contentSetId = '', documentName, documentIds = [], tabName=''){
        console.log("search call is coming in for adobe tracking")
        window.exPageTrack(
            "",tabName,true,"",
            {
                ContentSetId: contentSetId,
                DocumentId: documentIds.join('|'),
                DocumentName: documentName,
                actionType: 'DocRetrieval'
            })
    },

    trackFilterChange(filters = [], drugs = [], solutions = [], contentSetId = '') {
        window.exPageTrack(
            // userInputString parameter
            {
                actionType: 'SearchAndDocRetrieval',
                searchType: 'IV Search',
                countOfIVDrugsSelected: drugs.length,
                ivDrugNames: drugs.join('|'),
                countOfIVSolutionsSelected: solutions.length,
                ivSolutionNames: solutions.join('|'),
                ivFilters: filters.join('|')
            },
            "", "false", "",
            { ContentSetId: contentSetId })
    }
};

// Define a mapping from original keys to Amplitude keys
export const keyMap = {
    OrgName: "Org Name",
    OrgID: "Org ID",
    AuthType: "Auth Type",
    UserId: "Username",
    Profession: "Profession",
    FacilityName: "Facility Name",
    FacilityId: "Facility ID",
    UserType: "User Type",
    IssuerURL: "Issuer URL",
    AccountName: "Account Name"
};

const eventProps = {
    actionType: "Action Type",
    DatabaseName: "Database Name",
    DocumentName: "Document Name",
    ContentSetId: "Content Set ID",
    pageName: "Page Title",
    DocumentId: "Document Id",
    ContentName: "Content Name",

    searchType: "Search Type",
    searchTerm: "Search Term",
    spellSuggestionSelection: "Spell Suggestion Selection",
    searchWithNoResults: "Search with No results",

    interactionsDrugNames: "Interactions Drug Name(s)",
    interactionsAllergiesNames: "Interactions Allergies Name(s)",
    countOfDrugsForInteractions: "Count Of Drugs For Interactions",
    countOfAllergiesForInteractions: "Count Of Allergies For Interactions",
    drugs: "Drugs",
    interactions: "Interactions",


    ivDrugNames: "IV Drug Name(s)",
    ivSolutionNames: "IV Solution Name(s)",
    popularIVDrugPairs: "Popular IV Drug Pairs",
    countOfIVDrugsSelected: "Count Of IV Drugs Selected",
    countOfIVSolutionsSelected: "Count Of IV Solutions Selected",
    ivFilters: "IV Filters",

    neonatalMonographDrugName: "Neonatal Monograph Drug Name",
    pediatricMonographDrugName: "Pediatric Monograph Drug Name",
    neonatalFormulaNames: "Neonatal Formula Name(s)",
    pediatricFormulaNames: "Pediatric Formula Name(s)",
    neonatalCalculatorDrugNames: "Neonatal Calculator Drug Name(s)",
    pediatricCalculatorDrugNames: "Pediatric Calculator Drug Name(s)"
};

/* Method is used to track all pages in adobe and it is called commonly in EvidenceXpert layout for normal pages
 * Tabs in the page also track as pages so it is called directly from pages having tabs and used localStorage "Flag" to avoid twice call */
window.exPageTrack = function (userInputString, tabName, tabFlag, keyType, docRetrievalDetails)
{
    console.log("ENTER exPageTrack: userInputString, tabName===========", userInputString, tabName)

    try
    {
        localStorage.setItem("Flag", tabFlag);
        var amplitudeScriptId = document.getElementById("Amplitude_Script");
        var keywordValue;

        if (!amplitudeScriptId) {
            window.amplitude = undefined;
        }

        /* Function inside the setInterval call for every 1000ms until window._satellite get ready
         * Clear the setInterval variable once window.amplitude get ready
         * do we need this for micromedex3? */
        var exPageSatelliteVar = setInterval(exPageSatelliteTrack, 1000);

        function exPageSatelliteTrack() {
            /* code will execute once amplitude object get ready */
            if (window.amplitude) {

                var titleText = document.title;
                if (titleText && tabName) {
                    const [mainTitle] = titleText.split("-");
                    document.title = `${mainTitle}- ${tabName}`;
                }
                /*Instead of setting the key and value pair into satellite var, we will set them into VariableMap
                and pass to satellite.track method. It is to avoid the over tracking of dimensions. */
                var dimensionsMap = {};
                const identifyEvent = new window.amplitude.Identify();
                /* To check accountInfo global variable is not null */
                if (window.accountInfo){
                    for (var key in window.accountInfo) {
                        if (window.accountInfo[key] && keyMap[key] && window.accountInfo[key].toString().indexOf("$", 0) !== "0") {
                            keywordValue = window.accountInfo[key] !== 'NA' ? window.accountInfo[key]: "null";
                            dimensionsMap[key] = keywordValue.toString().trim();
                            identifyEvent.set(keyMap[key] , keywordValue.toString().trim());
                        }
                    }
                }
                console.log('accountInfo', window.accountInfo);
                console.log("userInputString", userInputString)
                if (userInputString) {
                    for (var key1 in userInputString) {
                        if ((userInputString[key1] || key1 === "spellSuggestionSelection" || key1 === "searchWithNoResults" || key1 === "popularIVDrugPairs")
                            && userInputString[key1].toString().indexOf("$", 0) !== "0") {
                            keywordValue = userInputString[key1];
                            dimensionsMap[key1] = keywordValue.toString().trim();
                            console.log("titleText",titleText)
                            console.log("keywordValue",keywordValue)
                            if(keywordValue==="Search"&& titleText==="IV Compatibility results - MICROMEDEX"){
                                titleText="IV Compatibility search - MICROMEDEX"
                            }
                            identifyEvent.set(keyMap[key1] , keywordValue.toString().trim());
                        }
                    }
                }

                if(docRetrievalDetails) {
                    var contentSetId,contentName,dbName;
                    var contentSetMap_Data = contentSetMap;
                    for(var key2 in docRetrievalDetails) {
                        if(docRetrievalDetails[key2] && docRetrievalDetails[key2].toString().indexOf("$", 0) !== "0") {
                            keywordValue = docRetrievalDetails[key2];
                            console.log(key2)
                            if (key2 === "ContentSetId") {
                                contentSetId = keywordValue;
                                if(contentSetMap_Data[contentSetId]){
                                    contentName = contentSetMap_Data[contentSetId]['contentName'];
                                    dbName = contentSetMap_Data[contentSetId]['databaseName'];
                                    dimensionsMap["ContentName"] = contentName;
                                    dimensionsMap["DatabaseName"] = dbName;
                                }else{
                                    contentName = "Not available";
                                    dbName      = "Not available";
                                    dimensionsMap["ContentName"] = contentName;
                                    dimensionsMap["DatabaseName"] = dbName;
                                }
                            }
                            dimensionsMap[key2] = keywordValue.toString().trim();
                            identifyEvent.set(keyMap[key2] , keywordValue.toString().trim());
                        }
                    }
                }

                const hasIdentifyProps = identifyEvent._propertySet instanceof Set
                  ? identifyEvent._propertySet.size > 0
                  : !isEmptyObject(identifyEvent._propertySet);

                if (!window.isIdentifyEventSent && hasIdentifyProps) {
                    window.amplitude.identify(identifyEvent);
                    window.isIdentifyEventSent = true;
                }
                if (["Chart-Drug-Drug", "Chart-Drug-Solution", "List-Drug-Drug", "List-Drug-Solution", "TPN"].includes(tabName)) {
                    let pageCounter = Number(sessionStorage.getItem('amplitudePageCounter') || 0);
                    pageCounter += 1;
                    sessionStorage.setItem('amplitudePageCounter', pageCounter.toString());
                    console.log("document.title before track", document.title + "-"+tabName);
                    dimensionsMap['actionType']= "Page View";
                    dimensionsMap['[Amplitude] Page Domain']= window.location.hostname;
                    dimensionsMap['[Amplitude] Page Counter']= pageCounter;
                    dimensionsMap['[Amplitude] Page Location']= window.location.href;
                    dimensionsMap['[Amplitude] Page Path']= window.location.pathname;
                    // dimensionsMap['[Amplitude] Page Title']= document.title + "-"+tabName;
                    dimensionsMap['[Amplitude] Page URL']= window.location.href;

                }

                const tabNameToUse = tabName ? "-"+tabName : tabName;
                console.log("document.title before track as tabNameToUse", tabNameToUse);
                dimensionsMap["pageName"] = document.title+tabNameToUse;
                console.log('dimensionsMap',dimensionsMap);
                trackAmplitudeEvent(dimensionsMap);
                /* Clear the setInterval variable to avoid the call after execution */
                clearInterval(exPageSatelliteVar);
            }
        }
    }
    catch(err)
    {
        console.log("exPageTrack Function Error");
    }
}

export function account_data(responseData) {
    const user = get(responseData, 'user', {});
    window.accountInfo = {
        OrgID: get(user, 'customerId') || get(responseData, 'customerId'),
        IssuerURL: get(responseData, 'issuerUrl'),
        AccountName: get(responseData, 'accountName') || get(user, 'orgName'),
        AuthType: normalizeAuthType(get(user, 'identityProvider') || get(responseData, 'AuthType')),
        Profession: get(user, 'profession') || get(responseData, 'profession'),
        userId: get(user, 'userId') || get(responseData, 'userId')
    }
}

export const getPageNameFromPathName= (pathName, search) => {
    let pageName = pathName;
    switch (pathName) {
        case "/ivCompatibilitySearch":
            pageName = TITLE_IV_COMPATIBILITY_SEARCH_PAGE;
            break;
        case "/ivCompatibility":
            pageName =TITLE_IV_COMPATIBILITY_RESULT_SUMMARY_PAGE;
            break;
        case "/ivResultDetails":
            pageName = TITLE_IV_COMPATIBILITY_RESULT_DETAILS_PAGE;
            break;
        case "/ivProductInfo":
            pageName = TITLE_IV_COMPATIBILITY_PRODUCT_DOCUMENT_PAGE;
            break;
        case "/login" :
            pageName = TITLE_LOGIN_PAGE;
            break;
        case "/home" :
            pageName = TITLE_HOME_PAGE;
            break;
        case "/drugInteractionSearch" :
            pageName = TITLE_DRUG_INTERACTION_SEARCH_PAGE;
            break;
        case "/drugInteraction" :
            pageName = TITLE_DRUG_INTERACTION_RESULT_SUMMARY_PAGE;
            break;
        case "/interactionDetails" :
            pageName = TITLE_DRUG_INTERACTION_DETAIL_PAGE;
            break;
        case "/drugPoints" :
            pageName = TITLE_MONOGRAPH_QUICK_ANSWERS;
            break;
        case "/inDepth" :
            pageName = TITLE_MONOGRAPH_IN_DEPTH_ANSWERS;
            break;
        case "/drugConsults" :
            pageName = TITLE_DRUG_CONSULT_PAGE;
            break;
        case "/chatbot" :
            pageName = TITLE_MICROMEDEX_ASSISTANT;
            break;
        case "/neoped":
            const searchParams = new URLSearchParams(search);
            const sectionFromUrl = searchParams.get("section") || SECTION_TYPE_DRUGS;
            pageName = sectionFromUrl === SECTION_TYPE_DRUGS ? TITLE_DRUG_MONOGRAPHS_SEARCH : TITLE_ENTERAL_FORMULAS;
            break;
        case "/neoped/monograph":
            pageName = TITLE_DRUG_MONOGRAPHS_RESULTS;
            break;
        case "/enteral/nutrientDetails":
            pageName = TITLE_ENTERAL_FORMULAS_NUTRIENT_DETAILS;
            break;
        case "/enteral/productnotes":
            pageName = TITLE_ENTERAL_FORMULAS_PRODUCT_NOTES;
            break;
        default:
            break;
    }
    return pageName;
}

function getSearchCategory(dimensionsMap, eventPropertiesMap) {
    if (dimensionsMap["searchType"]) {
        return "Search";
    }
    if (dimensionsMap["actionType"] === "DocRetrieval") {
        return "Document Retrieval";
    }
    if (dimensionsMap["actionType"] === 'Page View') {
        for (const key in dimensionsMap) {
            eventPropertiesMap[key] = dimensionsMap[key];
        }
        const EXCLUDED_PROPERTIES = ['actionType', 'AccountName', 'AuthType', 'OrgID'];
        EXCLUDED_PROPERTIES.forEach(prop => delete eventPropertiesMap[prop]);
        console.log("dimensionsMap ===============",dimensionsMap,"eventPropertiesMap==========", eventPropertiesMap);
        return "[Amplitude] Page Viewed";
    }

    return null;
}

function trackAmplitudeEvent(dimensionsMap) {
    let eventPropertiesMap = {};
    // Remove unwanted keys from
    console.log("dimensionsMap before modification ...",dimensionsMap);
    if(dimensionsMap["actionType"] === undefined && dimensionsMap["pageName"] === "Drug Interaction detail - MICROMEDEX"){
        dimensionsMap["actionType"] = "DocRetrieval";
        dimensionsMap["DatabaseName"] = "DRUGREAX";
    }
    delete dimensionsMap["ContentName"];
    delete dimensionsMap["ContentSetId"];
    const pageName = dimensionsMap["pageName"];
    delete dimensionsMap["pageName"];
    for (const key in dimensionsMap) {
        if (eventProps[key]) {
            eventPropertiesMap[eventProps[key]] = decodeURIComponent(dimensionsMap[key]);
        }
    }
    console.log("eventPropertiesMap ...",eventPropertiesMap);
    const event_name = getSearchCategory(dimensionsMap, eventPropertiesMap);
    console.log("event_name ...",event_name);
    if (Object.keys(eventPropertiesMap).length === 0) {
        eventPropertiesMap = { "Page Title": pageName || "" };
    }

    if (event_name) {
        const event = {
            event_type: event_name,
            event_properties: eventPropertiesMap
        };
        console.log("event object ...",event);
        trackEventSafely(event); // Use the safe tracking function
    }
}

let amplitudeReady = false;
let pendingAmplitudeActions = [];
let amplitudeReadyInterval = null;

// Runs the supplied action as soon as the Amplitude SDK is available, preserving call order.
function runWhenAmplitudeReady(action) {
    if (amplitudeReady || window.amplitude) {
        amplitudeReady = true;
        action();
    } else {
        pendingAmplitudeActions.push(action);
        if (!amplitudeReadyInterval) {
            amplitudeReadyInterval = setInterval(function () {
                if (window.amplitude) {
                    amplitudeReady = true;
                    clearInterval(amplitudeReadyInterval);
                    amplitudeReadyInterval = null;
                    while (pendingAmplitudeActions.length) {
                        pendingAmplitudeActions.shift()();
                    }
                } else {
                    console.log("Waiting for Amplitude to be ready...");
                }
            }, 1000);
        }
    }
}

function trackEventSafely(event) {
    runWhenAmplitudeReady(function () {
        window.amplitude.track(event);
        console.log("Amplitude event tracked:", event);
    });
}

// Sets the User ID as Amplitude's native identifier and Auth Type / Profession as user properties.
export function setAmplitudeUserProperties() {
    runWhenAmplitudeReady(function () {
        if (window.accountInfo && window.accountInfo.userId) {
            window.amplitude.setUserId(window.accountInfo.userId.toString().trim());
        }
        const identifyEvent = new window.amplitude.Identify();
        if (window.accountInfo) {
            for (var key in window.accountInfo) {
                if (window.accountInfo[key] && window.accountInfo[key].toString().indexOf("$", 0) !== "0" && keyMap[key]) {
                    const keywordValue = window.accountInfo[key] !== 'NA' ? window.accountInfo[key] : "null";
                    identifyEvent.set(keyMap[key], keywordValue.toString().trim());
                }
            }
        }
        window.amplitude.identify(identifyEvent);
        console.log("Amplitude user properties set:", window.accountInfo);
    });
}

// Fires when the user submits their email on the login (Trusted Account) page.
export function trackAuthScreenSubmit() {
    trackEventSafely({
        event_type: AUTH_EVENTS.AUTH_SCREEN_SUBMIT,
        event_properties: {}
    });
}

// Fires on a successful authentication, after setting the authenticated user properties.
export function trackAuthSuccess() {
    setAmplitudeUserProperties();
    trackEventSafely({
        event_type: AUTH_EVENTS.AUTH_SUCCESS,
        event_properties: { Action: AUTH_ACTION.LOGIN }
    });
}

// Fires when the user logs out, before the session is torn down.
export function trackLogout() {
    trackEventSafely({
        event_type: AUTH_EVENTS.LOGOUT,
        event_properties: {}
    });
}

export const pageViewTrackingEnrichment = () => {
    return {
        name: 'page-view-tracking-enrichment',
        type: 'enrichment',
        setup: async () => undefined,
        execute: async (event) => {
            if (event.event_type !== '[Amplitude] Page Viewed') {
                return event;
            }
            event.event_properties = {
                ...event.event_properties,
                '[Amplitude] Page Title' : document.title
            };
            return event;
        },
    };
};

export const shouldTrackPageViewEvent = () => {
    if (sessionStorage.getItem(NO_PAGE_VIEW_TRACKING)) {
        sessionStorage.removeItem(NO_PAGE_VIEW_TRACKING);

        return false;
    }
    const isNeoPedMonograph = window.location.href.includes("/neoped/monograph");
    const isLogin = window.location.href.includes("/login");

    if (isLogin) {
        return false;
    }

    if (!isNeoPedMonograph) {
        return true;
    }
    const params = new URLSearchParams(window.location.hash.split('?')[1] || '');
    if (params.get("documentId") === sessionStorage.getItem(NEO_PED_DRUG_ID_KEY)) {
        return false;
    }
    sessionStorage.removeItem(NEO_PED_DRUG_ID_KEY);

    return true;
}
